import * as React from "react";

import { useButton_unstable } from "@fluentui/react-button";

import { AppButtonProps, AppButtonState } from "./AppButton.types";
import { useAppButtonState } from "./useAppButtonState";
import { useMergedTooltipAndKeytipRef } from "./useMergedTooltipAndKeytipRef";

/**
 * Given user props, returns state for an `AppButton`.
 */
export const useAppButton = (
  props: AppButtonProps,
  ref: React.Ref<HTMLButtonElement>
): AppButtonState => {
  const { disabled } = props;

  const mergedRefWithKeytip = useMergedTooltipAndKeytipRef(props, ref);

  // 'type' override here needed so that our types (e.g. "AppButtonProps") aren't assigned to the HTML element
  // TODO: should disabledFocusable be the same as disabled? aria-disabled requires disabledFocusable to be set here
  const buttonState = useButton_unstable(
    { ...props, type: "button", disabledFocusable: disabled },
    mergedRefWithKeytip
  );

  return useAppButtonState(props, buttonState);
};
